import { call, put, select } from 'redux-saga/effects';

import api from 'api';
import { IWorkoutResponse } from 'api/components/PersonalPlan/types';

import { notifyError } from 'store/notifications/actions';
import { getWorkoutError, getWorkoutRequest, getWorkoutSuccess, resetWorkout } from 'store/personalPlan/actions';

import { IWorkoutExtended } from 'types/personalPlan';
import { WorkoutState } from 'types/workout';

import { selectActiveWorkout } from '../selectors';

export function* getWorkout() {
    try {
        const activeWorkout: IWorkoutExtended | undefined = yield select(selectActiveWorkout);

        if (!activeWorkout) {
            yield put(resetWorkout());

            return;
        }

        if (activeWorkout.completeness === WorkoutState.notAvailable) return;

        const { workout_id, type, day_number } = activeWorkout;

        yield put(getWorkoutRequest());

        const workout: IWorkoutResponse = yield call(api.personalPlan.getWorkout, {
            workout_id,
            workout_type: type,
            day_number,
        });

        yield put(getWorkoutSuccess(workout));
    } catch (error: any) {
        console.error('Get personal plan error: ', error.message);

        yield put(getWorkoutError());
        yield put(notifyError({ message: 'basics.appError' }));
    }
}
